module.exports = __webpack_public_path__ + "static/media/etienne.de4628a7.jpg";